import { render, staticRenderFns } from "./dialogbox.vue?vue&type=template&id=d25f963e&scoped=true&"
import script from "./dialogbox.vue?vue&type=script&lang=js&"
export * from "./dialogbox.vue?vue&type=script&lang=js&"
import style0 from "./dialogbox.vue?vue&type=style&index=0&id=d25f963e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d25f963e",
  null
  
)

export default component.exports